import React from 'react';
import { Link } from 'react-router-dom';
import { selectPlan } from 'State/Plans';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import './Banner.css';

export const Banner = ({ image, className, bannerLink, promoCode, planId, handleClickBanner = null }) => {
  const onClick = () => {
    if (planId) {
      planId && selectPlan(planId);
      trackEvent(TRACKING_ENUMS.EVENT_BUTTON_LINK_SELECTED, {
        page_button_text: 'Renew Now',
        page_name: 'account upgrade option offer',
        page_type: 'account',
      });
    }
    if (handleClickBanner) handleClickBanner();
  };

  // if no promo code, plan id or click handler, banner is not clickable
  if (!promoCode && !planId && !handleClickBanner) {
    return (
      <div className="imageContainer">
        <div className="desktopImage">
          <img src={image.desktop} className={className}></img>
        </div>
        <div className="mobileImage">
          <img src={image.mobile} className={className}></img>
        </div>
      </div>
    );
  }

  if (promoCode) {
    return (
      <div className="imageContainer tmtBannerPromo">
        <button className="desktopImage" onClick={onClick}>
          <img src={image.desktop} className={className}></img>
        </button>
        <button className="mobileImage" onClick={onClick}>
          <img src={image.mobile} className={className}></img>
        </button>
      </div>
    );
  }

  return (
    <div className="imageContainer">
      <Link className="desktopImage" to={bannerLink} onClick={onClick}>
        <img src={image.desktop} className={className}></img>
      </Link>
      <Link className="mobileImage" to={bannerLink} onClick={onClick}>
        <img src={image.mobile} className={className}></img>
      </Link>
    </div>
  );
};
